'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TextMorph: ()=>TextMorph
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
function TextMorph({ children, as: Component = 'p', className, style, variants, transition }) {
    const uniqueId = (0, external_react_namespaceObject.useId)();
    const characters = (0, external_react_namespaceObject.useMemo)(()=>{
        const charCounts = {};
        return children.split('').map((char)=>{
            const lowerChar = char.toLowerCase();
            charCounts[lowerChar] = (charCounts[lowerChar] || 0) + 1;
            return {
                id: `${uniqueId}-${lowerChar}${charCounts[lowerChar]}`,
                label: ' ' === char ? '\u00A0' : char
            };
        });
    }, [
        children,
        uniqueId
    ]);
    const defaultVariants = {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    };
    const defaultTransition = {
        type: 'spring',
        stiffness: 280,
        damping: 18,
        mass: 0.3
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Component, {
        className: (0, index_cjs_namespaceObject.cn)(className),
        "aria-label": children,
        style: style,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.AnimatePresence, {
            mode: "popLayout",
            initial: false,
            children: characters.map((character)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.span, {
                    layoutId: character.id,
                    className: "inline-block",
                    "aria-hidden": "true",
                    initial: "initial",
                    animate: "animate",
                    exit: "exit",
                    variants: variants || defaultVariants,
                    transition: transition || defaultTransition,
                    children: character.label
                }, character.id))
        })
    });
}
exports.TextMorph = __webpack_exports__.TextMorph;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TextMorph"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
